"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const clsx_1 = require("clsx");
const FontIcon_1 = __importDefault(require("../icon/FontIcon"));
const __1 = require("..");
const Toast = (_a) => {
    var { className, closeIcon, content, leftIcon, onClickClose, placement, show, ariaLabel } = _a, otherProps = __rest(_a, ["className", "closeIcon", "content", "leftIcon", "onClickClose", "placement", "show", "ariaLabel"]);
    if (!show) {
        return null;
    }
    // As you cannot apply multiple transforms there's one special case where if both vertical and horizontal are centered
    const xyCentered = placement.horizontal === 'center' && placement.vertical === 'center';
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.clsx)('tk-toast', className, { ['tk-toast__vertical-horizontal-center']: xyCentered,
            [`tk-toast__horizontal-${placement.horizontal}`]: !xyCentered,
            [`tk-toast__vertical-${placement.vertical}`]: !xyCentered
        }), "aria-label": ariaLabel }, otherProps, { children: [leftIcon && (0, jsx_runtime_1.jsx)(FontIcon_1.default, { className: "tk-toast__icon-left", iconName: leftIcon }), content, closeIcon && (0, jsx_runtime_1.jsx)(__1.SvgIcon, { className: "tk-toast__icon-right", icon: __1.Icons.Cross, onClick: onClickClose })] })));
};
exports.Toast = Toast;
exports.Toast.defaultProps = {
    placement: {
        horizontal: 'center',
        vertical: 'center'
    }
};
exports.Toast.propTypes = {
    className: PropTypes.string,
    closeIcon: PropTypes.bool,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    leftIcon: PropTypes.string,
    onClickClose: PropTypes.func,
    placement: PropTypes.any,
    show: PropTypes.bool.isRequired,
    ariaLabel: PropTypes.string,
};
